import CriarContaCnpj from '@/modules/criar-conta/CriarContaCnpj.vue';
import CriarContaEmpresaCadastrada from '@/modules/criar-conta/criar-usuario/CriarContaEmpresaCadastrada.vue';
import HeaderExterno from '@/modules/criar-conta/HeaderExterno.vue';
import CriarContaNovaEmpresa from '@/modules/criar-conta/CriarContaNovaEmpresa.vue';
import CriarUsuario from '@/modules/criar-conta/criar-usuario/CriarUsuario.vue';

export default [
  {
    path: '/nova-conta',
    name: 'criar-conta',
    components: {
      default: CriarContaCnpj,
      header: HeaderExterno,
    },
  },
  {
    path: '/conta-existente',
    name: 'conta-existente',
    components: {
      header: HeaderExterno,
      default: CriarContaEmpresaCadastrada,
    },
  },
  {
    path: '/nova-conta-empresa',
    name: 'nova-conta-empresa',
    components: {
      header: HeaderExterno,
      default: CriarContaNovaEmpresa,
    },
  },
  {
    path: '/criar-usuario/:id',
    name: 'criar-usuario',
    components: {
      header: HeaderExterno,
      default: CriarUsuario,
    },
  },
];
